<template>
  <div class="head-page">
    <Header :title="$t('tradelst.title')" />
    <div class="trade-lst-tab-box" style="display: flex;height: 38px;line-height: 38px;">
      <div style="width: 75%;padding-left: 10px;">
        <span
            class="trade-lst-tab"
            :class="frm.status == item.value ? 'trade-lst-tab-select' : ''"
            v-for="(item, index) in columns1"
            :key="index"
            @click="changeType(item)"
            >{{ item.label }}</span
          >
      </div>
      <div style="width: 25%;padding-right: 10px;" class="txt-right">
        <span @click="showPicker = true" class="link-btn"
            >{{ value }} <van-icon name="arrow-down"
          /></span>
      </div>
    </div>
    <div class="trade-lst-databox" v-if="list.length > 0">
      <van-pull-refresh
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('common.nomore')"
          :loading-text="$t('common.loading')"
          :error-text="$t('common.errortxt')"
          @load="onLoad"
        >
          <div v-for="(item, index) in list" :key="index">
            <div style="margin: 10px 0px 0px 0px;">
              <TradeRecordItem
                v-if="item.status != 2"
                :item="item"
                @cancel-Order="cancelOrder"
              />
              <TradeViewItem :item="item" v-if="item.status == 2" />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else class="trade-lst-databox">
      <van-empty :description="$t('common.nodata')" />
    </div>
    <van-popup v-model="showPicker" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { TradeViewItem } from "./components/index";
import TradeRecordItem from "../Trade/components/recorditem.vue";
export default {
  name: "TradeList",
  components: { Header, TradeViewItem, TradeRecordItem },
  data() {
    return {
      value: null,
      showPicker: false,
      columns: [
        { value: 0, label: this.$t("common.all") },
        { value: 1, label: this.$t("common.buy") },
        { value: 2, label: this.$t("common.sell") },
      ],
      columns1: [
        { value: 1, label: this.$t("tradelst.tab1") },
        { value: 2, label: this.$t("tradelst.tab2") },
        { value: 3, label: this.$t("tradelst.tab3") },
      ],
      recordtype: 0,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      frm: {
        type: 0,
        page: 1,
        limit: 10,
        status: 1,
      },
    };
  },
  mounted() {
    this.value = this.columns[0].label;
    this.onLoad();
  },
  methods: {
    onConfirm(val) {
      this.value = val.label;
      this.frm.type = val.value;
      this.showPicker = false;
      this.onRefresh();
    },
    changeType(val) {
      this.frm.status = val.value;
      this.onRefresh();
    },
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "tradegetOrderList",
        data: this.frm,
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.frm.limit) {
            this.finished = true;
          } else {
            this.frm.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.frm.page = 1;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    cancelOrder(id) {
      this.postcancelOrder(id);
    },
    async postcancelOrder(id) {
      await this.$http({
        method: "post",
        url: "tradecancelOrder",
        data: { bb_id: id },
      }).then((res) => {
        this.$toast.success(res.msg);
        this.onRefresh();
      });
    },
  },
};
</script>

<style>
</style>
